export enum PeripheralTypeEnum {
    Printer = 2,
    IButtonReader = 3,
    MagneticCardReader = 4,
    RfidReader = 5,
    CITPanel = 6,
    UPS = 7,
    ChequeScanner = 8,
    Unknown = 9,
    RearPrinter = 10,
    RearIButtonReader = 11,
    FingerprintScanner = 12,
    NFCReader = 13,
    CardReader = 14,
}

export function peripheralTypeEnumLabel(peripheralType: PeripheralTypeEnum): string {
    switch (peripheralType) {
        case PeripheralTypeEnum.Printer:
            return "enum.peripheral_type.printer";
        case PeripheralTypeEnum.IButtonReader:
            return "enum.peripheral_type.iButtonReader";
        case PeripheralTypeEnum.MagneticCardReader:
            return "enum.peripheral_type.magneticCardReader";
        case PeripheralTypeEnum.RfidReader:
            return "enum.peripheral_type.rfidReader";
        case PeripheralTypeEnum.CITPanel:
            return "enum.peripheral_type.cITPanel";
        case PeripheralTypeEnum.UPS:
            return "enum.peripheral_type.uPS";
        case PeripheralTypeEnum.ChequeScanner:
            return "enum.peripheral_type.chequeScanner";
        case PeripheralTypeEnum.RearPrinter:
            return "enum.peripheral_type.rearPrinter";
        case PeripheralTypeEnum.RearIButtonReader:
            return "enum.peripheral_type.rearIButtonReader";
        case PeripheralTypeEnum.FingerprintScanner:
            return "enum.peripheral_type.fingerprintScanner";
        case PeripheralTypeEnum.NFCReader:
            return "enum.peripheral_type.nfcReader";
        case PeripheralTypeEnum.CardReader:
            return "enum.peripheral_type.cardReader";
        default:
            return "common.unknown";
    }
}
